type GetVehicleScopedDepositProps = {
  currentVehicleId: string;
  deposit: number | undefined;
  persistedVehicleId: string | undefined;
};

export const getVehicleScopedDeposit = ({
  currentVehicleId,
  deposit,
  persistedVehicleId,
}: GetVehicleScopedDepositProps) => {
  if (!persistedVehicleId || persistedVehicleId !== currentVehicleId) {
    return undefined;
  }

  return deposit;
};
